import { isUnspecifiedDisease } from "@domain/medical-condition/medical-condition";
import { useFormatMedicalCondition } from "@domain/medical-condition/use-medical-condition";
import { useFormatPatients } from "@domain/patient/hooks/use-patients";
import { isPendingPatient, Patient, PendingPatient } from "@domain/patient/patient";
import styled from "@emotion/styled";
import Tippy from "@tippyjs/react";
import { PatientDetailsContent } from "@ui/pages/patient-details/components/patient-details/patient-details-column";
import { colors } from "@ui/style/colors";
import React, { useState } from "react";

interface PatientInformationsTooltipProps {
	patient: Patient | PendingPatient;
}

const SEPARATOR = " - ";

export const PatientInformationsTooltip: React.FC<PatientInformationsTooltipProps> = (
	props: PatientInformationsTooltipProps,
) => {
	const { patient } = props;
	const { formatPatientName } = useFormatPatients();
	const { formatDisease } = useFormatMedicalCondition();
	const [textColor, setTextColor] = useState<string>();

	return (
		<StyledTippy
			interactive
			arrow={false}
			content={<PatientDetailsContent patient={patient} isLightMode isEditable={false} />}
			onShow={() => setTextColor(colors.primary)}
			onHide={() => setTextColor(undefined)}
			placement="bottom"
		>
			<MedicalCondition className="p-size-xs-semi-bold" color={textColor}>
				<PatientName className="p-size-xs-bold" color={textColor}>
					{formatPatientName(patient)}
				</PatientName>
				{!isPendingPatient(patient) &&
					!isUnspecifiedDisease(patient.disease) &&
					SEPARATOR + formatDisease(patient.disease)}
			</MedicalCondition>
		</StyledTippy>
	);
};

const MedicalCondition = styled.span<{ color?: string }>`
	color: ${({ color = colors.grey }) => color};

	&:hover,
	&:hover * {
		color: ${colors.primary};
	}
`;

const PatientName = styled.span<{ color?: string }>`
	color: ${({ color = colors.black }) => color};
`;

const StyledTippy = styled(Tippy)`
	background-color: ${colors.white};
	border: 1px solid ${colors.primary25};
	padding: 16px;
	border-radius: 16px;
	box-shadow: 0px 2px 8px 0px rgba(38, 38, 48, 0.16);
`;
